import { render, staticRenderFns } from "./ReportsCapabilitiesRequiringDevelopment.vue?vue&type=template&id=40d97685&"
import script from "./ReportsCapabilitiesRequiringDevelopment.vue?vue&type=script&lang=js&"
export * from "./ReportsCapabilitiesRequiringDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports